import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { enc, AES, mode, pad } from 'crypto-js';
import { routes } from '../../../redux/api/routes';
const { localStorageVar, redirectURLCNetVar, bootAPIUrl, users } = routes;

/*Actions*/
import {
	saveAccountDetail,
	saveZipCodeDetail,
	saveZipCode,
	saveAccountNumber,
	saveAccountNumberDetails,
	getShippingAddresses,
	saveProductLine,
	updateInvalidAttempt,
	saveShippingAddresses,
	saveInvalidAttempt,
	getRegistrationHelpDoc,
	savePostLoginSearchKeyword,
	resetSearchKeywordSuggestionList,
	resetHomePageObjectInStore,
	saveSelectedAccountAndPriceSource,
	saveAccountNumberPostLogin,
	showHideAutoSelect,
	saveSearchKeywordSuggestionList,
	saveProductLineFilters,
	resetProductNumberKeywordResultList,
	getSearchKeywordSuggestionList,
	resetProductAvailabilityResultList,
	getAccountDetails,
    checkCredentials,
	resetUserDetails,
	saveUserDetails,
	getUserDetails,
	getApprovedAccounts,
	saveApprovedAccountDetails,
	getLocalUserDetails,
	saveSSORegistrationDetails,
	saveUserOtherDetails,
	getAssets,
	populateLatestHomePageAssets,
	updateHomePageAssetsFromBackup,
	saveProductLineNarrowYourResultsFilters,
	getProductLineNarrorYourResultFilters,
	showAccountDetailProgress,
	showZipCodeLoading,
	getAddressList,
	postPunchOutData,
	getPunchOutData,
	getNonGEASSOUserAccounts,
	ajaxRequestCompleted,
	ajaxRequestInitiated,
	logout,
	// getProductLineList
} from '../../../redux/actions';

import {
	manipulateClipBoardToKeepNumericsOnly
} from '../../../redux/util';

/*Dialogs*/
import NoProductResultsFoundOverlayDialog from '../../dialogs/genericOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import { sendRequest } from '../../../redux/api/sendRequest';

class Home extends Component {

    constructor(props){
        super(props);
        this.state = {
			westRegion : false,
			showAccountNotSetupProperlyOverlayDialog: false,
			showOauthMessageForEmployeeUserDialog : false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
			isChecked: false,
			textAreaValue: '',
            errorMessage: '',

            requiredFieldError: "The fields highlighted in red are required.",

            customLoginErrorMessage: '',
            productNumberError: '',
			ssoId: '',
			password: '',

			disableGoButtons: false,

			showSuggestion: false,
			showSearchLoading: false
        }
		this.fetchUserDetails = this.fetchUserDetails.bind(this);
		this.updateAccountListToLocalStorage = this.updateAccountListToLocalStorage.bind(this);
		this.saveUserOtherDetailsToLocalStorage = this.saveUserOtherDetailsToLocalStorage.bind(this);
		this.saveRegistraionDetailsAndRedirect = this.saveRegistraionDetailsAndRedirect.bind(this);
		this.fetchHomePageAssets = this.fetchHomePageAssets.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.afterLoginProcess = this.afterLoginProcess.bind(this);
		this.processUserdetails = this.processUserdetails.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
	}

	handleCheckboxChange = () => {
		this.setState((prevState) => {
		  return { isChecked: !prevState.isChecked };
		});
	  };

	  handleTextAreaChange = (event) => {
		this.setState({ textAreaValue: event.target.value });
	  };

	setCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	    var expires = "expires="+d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	handleNewUserRegistrationDocuments(event) {
		event && event.preventDefault();
		const self = this;
		const { registrationHelpDoc } = self.props.state.resources;
		self.setState({
			errorMessage: ''
		});
		if(registrationHelpDoc && registrationHelpDoc.responseObject) {
			window.open(registrationHelpDoc.responseObject, '_blank');
		} else {
			self.props.getRegistrationHelpDoc(`requestType=getRegistrationHelpDoc`, response => {
				if(!response.status) {
					self.setState({
						errorMessage: 'Error occured while fetching documents.'
					})
				} else {
					window.open(response.responseObject, '_blank');
				}
			});
		}
	}

	getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for(var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) === 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}

	delCookie(cname) {
		document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"`;
	}

    componentDidMount() {
		window.scrollTo(0, 0);
		var self = this;
		//reset keyword and suggestion list
		self.props.saveProductLine("");
		self.props.savePostLoginSearchKeyword("");
		self.props.resetSearchKeywordSuggestionList();
		self.props.resetHomePageObjectInStore();
		self.props.saveSelectedAccountAndPriceSource({
			selectedAccount: null,
			selectedPriceSource: null,
		});

		self.setState({
			showSuggestion: false
		});

		// TO DO: TBD //Get all static product line list
		// if(state.product.productLineList.length === 0)
        // 	dispatch(getProductLineList());

        var localStrogeObj = this.getLocalStorageVar(localStorageVar);

        if((localStrogeObj && !(new Date() > new Date(localStrogeObj.expiryTime)))) {
			if(localStrogeObj.sso) {
				// update userdetails from localstorage in store so that we can use it later
				self.props.saveUserDetails({
					firstName: localStrogeObj.firstName,
					lastName: localStrogeObj.lastName,
					email: localStrogeObj.email,
					sso: localStrogeObj.sso,
					gessouid: localStrogeObj.gessouid,
					typeOfUser: localStrogeObj.typeOfUser,
					validUser: true,
					isASM: localStrogeObj.isASM?localStrogeObj.isASM:null,
					otherASM: localStrogeObj.otherASM?localStrogeObj.otherASM:null,
					isInDL: localStrogeObj.isInDL?localStrogeObj.isInDL:null,
					isSiteManagementAccess: localStrogeObj.isSiteManagementAccess?localStrogeObj.isSiteManagementAccess:null,
					isAdmin: localStrogeObj.isAdmin?localStrogeObj.isAdmin:null,
					jwt: localStrogeObj.jwt,
					entryDN: localStrogeObj.entryDN,
					adminAccess : localStrogeObj.adminAccess,
					manageSiteAccess : localStrogeObj.manageSiteAccess,
					punchOutAccess : localStrogeObj.punchOutAccess,
					punchOutAccNumber : localStrogeObj.punchOutAccNumber,
					punchOutSalesNumber : localStrogeObj.punchOutSalesNumber,
					punchoutRedirectUrl: localStrogeObj.punchoutRedirectUrl,
					punchoutPostUrl: localStrogeObj.punchoutPostUrl,
					punchoutBuyerCookie: localStrogeObj.punchoutBuyerCookie,
					punchoutFromIdentity: localStrogeObj.punchoutFromIdentity,
					punchoutToIdentity: localStrogeObj.punchoutToIdentity,
					punchoutSenderIdentity: localStrogeObj.punchoutSenderIdentity,
					punchoutSenderPassword: localStrogeObj.punchoutSenderPassword,
					punchoutUserAgent: localStrogeObj.punchoutUserAgent,
					payloadID: localStrogeObj.payloadID,
					isNonGEASsoUser: localStrogeObj.isNonGEASsoUser,
					isManRepSsoUser: localStrogeObj.isManRepSsoUser,
					omAccess : localStrogeObj.omAccess,
					isOktaLogin : localStrogeObj.isOktaLogin,
				});
				//If users credentials are valid but profile is not available, then redirect to registration page
				if(localStrogeObj.typeOfUser === 'customer') {
					self.fetchUserDetails(localStrogeObj.sso, localStrogeObj.typeOfUser);
				} else if (localStrogeObj.isNonGEASsoUser) {
					self.fetchNonGEASSOUserDetails(localStrogeObj.sso);
				} else {
					self.fetchHomePageAssets();
				}
			}
        }
		self.afterLoginProcess();
    }

	componentWillMount() {
		let temp = this.getCookie('ssoId');
		this.setState({ssoId:(temp?temp:'')});
	}

	handlePunchLoginSubmit(event) {
		event.preventDefault()
		const self = this;
		
		if(!self.state.textAreaValue){
			return "";
		}
		
		let punchOutInitialPostUrl = "https://customernetapi-qa.geappliances.com/api/cnet/oAuth/punchOut";
		self.props.postPunchOutData(self.state.textAreaValue,punchOutInitialPostUrl, response => {
				console.log(response)
				const regex = /<URL>([\s\S]*?)<\/URL>/;
				const match = response.responseMessage.match(regex);
				if (match) {
    				const urlValue = match[1];
					window.open(urlValue, '_blank');
				}

			})
	}

	handleSSOLoginSubmit(event, retry = false) {
		event.preventDefault();
		window.location.href = routes.ssoGEUrl;
	}

    handleBlurEvent(event) {
        if(event.target.value !== '') {
			var self = this;
            //Check valid account number only something is entered
            // this.setState({disableGoButtons: true});
            if(event.target.name === "accountNumber") {
				if(event.target.value.length < 7) {
                    event.target.className = "error";
                } else {
					self.props.showAccountDetailProgress(true);
					self.props.getAccountDetails(`accountNumber=${event.target.value}&requestType=getAccountDetails`, false, response => {
						if(response.status) {
							//callback && callback(response);
							// once service will start working properly move this code in above if condition
							if(response.responseObject.length > 0) {
								self.props.showAccountDetailProgress(false);
								self.props.saveAccountDetail(response);
								self.setState({
									accountDetails:response.responseObject
								}, () => {
									self.props.getAddressList(`accountNumber=${response.responseObject[0].ACCOUNTNUMBER}&partyId=${response.responseObject[0].PARTYID}&requestType=getAddressList`, false, resp => {
									if(resp.status){
										this.setState({addressListResponse: resp.responseObject})
									}
									})
								})
							}
						}
					})}
					self.props.saveAccountNumber(event.target.value);
					}
            else if(event.target.name === "zipCode") {
                if(event.target.value.length !== 5) {
                    event.target.className = "error";
                } else {
					//To validate zipcode use tax service
					self.props.saveZipCodeDetail(null);
					self.props.showZipCodeLoading(true);
					const zipCode = event.target.value;
					const { addressListResponse } = this.state;
					const country = addressListResponse[0].COUNTRY;
					self.props.getShippingAddresses(`zip=${event.target.value}&accountNumber=${self.accountNumberInput.value}&country=${country} `, false, response => {
						self.props.showZipCodeLoading(false);
						self.props.saveZipCodeDetail(response);
						if(response.responseObject) {
							self.props.saveShippingAddresses({
								zipCode,
								details: response.responseObject
							});
						}
					}, true);
                }
				self.props.saveZipCode(event.target.value);
            }
        }

    }

	acceptsOnlyNumbers(event) {
        if(!(event.charCode >= 48 && event.charCode <= 57)) {
            event.preventDefault();
        }
    }

    handleChange(event) {
		event.target.className = event.target.value === ""?"error":""
		//Reset details on change so that text field of product numebr can be disabled
		if(event.target.name === "accountNumber") {
			this.props.saveAccountNumberDetails(null);
		} else if(event.target.name === "zipCode") {
			this.props.saveZipCodeDetail(null);
		}
    }

    handleChangeProductNumber(event) {
		var self = this;
		self.setState({showSearchLoading: false, showSuggestion: false});
        var value = event.target.value,
            lastCharacter = value.substring(value.length-1),
            lastKeyword = event.target.value.split(" ");
        if(lastCharacter === " ")lastKeyword.pop();
        lastKeyword = lastKeyword[lastKeyword.length-1];

        //save all search string in store for showing next result page
        self.props.savePostLoginSearchKeyword(value);

        //Check if last character is space or not
        if(lastCharacter === " " || lastKeyword.length <= 2) {
            //in case of space reset suggestion list
            self.props.resetSearchKeywordSuggestionList();
        } else if(lastKeyword !== "" && lastKeyword.length > 2) {
			self.setState({showSearchLoading: true, showSuggestion: true});
			self.props.saveSearchKeywordSuggestionList(null);
            self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${lastKeyword}&count=5`, (response) => {
				self.props.saveSearchKeywordSuggestionList(response.responseObject);
				self.setState({showSearchLoading: false});
			});
        }
    }

    handleChangeProductLine(event) {
        //save product line selected dropdown value
        this.props.saveProductLine({
            navigationState: event.target.value,
            label: event.target.options[event.target.selectedIndex].innerHTML
        });
    }

    handleLoginFormChange(fieldName,event) {
        this.setState({
            customLoginErrorMessage: (this.ssoIdInput.value.length === 9)?'':this.state.customLoginErrorMessage
        });
        if(event.target.value === "")
            event.target.className = "error"
        else
            event.target.className = ""
        this.setState({[fieldName]:event.target.value})
    }

    handleProductNumberSubmit(event) {
        event.preventDefault();
		var self = this;
        this.setState({
            errorMessage: (this.productNumberInput.value === "" || this.accountNumberInput.value === "" || this.zipCodeInput.value === "")?this.state.requiredFieldError:''
        });
        if(!this.validateFields([{
                field: this.accountNumberInput
            }, {
                field: this.zipCodeInput,
                minLength: 5
            }, {
                field: this.productNumberInput
            }])
        ) {
            if(!(this.props.state.product.zipCodeDetail && this.props.state.product.zipCodeDetail.status && this.props.state.product.accountDetail && this.props.state.product.accountDetail.status)) {
                this.setState({
                    errorMessage: 'Please wait while fields are being validated.'
                });
            } else {
                this.setState({
                    errorMessage: ''
                });
				//Parameters were saved on change of text field in store, so just redirect to result page and read from store.
                this.props.saveAccountNumber(this.accountNumberInput.value);
                this.props.saveZipCode(this.zipCodeInput.value);
				//make service call and check whether we result found for given search criteria
				self.setState({
					errorMessage: '',
					disableGoButtons: true
				});
				self.props.resetProductAvailabilityResultList();
				self.props.checkAndSetSearchResult(
					'product-number',
					self.accountNumberInput.value,
					self.zipCodeInput.value,
					self.productNumberInput.value,
					"",
					() => {
						self.setState({
							errorMessage: 'No results found.',
							disableGoButtons: false
						});
					}
				);
            }
        }
    }

    handleProductLineSubmit(event) {
        event.preventDefault();
		var self = this;
        this.setState({
            errorMessage: (this.productLineSelect.value === "" || this.accountNumberInput.value === "" || this.zipCodeInput.value === "")?this.state.requiredFieldError:''
        });
        if(!this.validateFields([{
                field: this.accountNumberInput
            }, {
                field: this.zipCodeInput,
                minLength: 5
            }, {
                field: this.productLineSelect
            }])
        ) {
            if(!(self.props.state.product.zipCodeDetail && self.props.state.product.zipCodeDetail.status === true && this.props.state.product.accountDetail && this.props.state.product.accountDetail.status === true)) {
                self.setState({
                    errorMessage: 'Please wait fields are being validated.'
                });
            } else {
                self.setState({
                    errorMessage: ''
                });
                self.props.saveAccountNumber(self.accountNumberInput.value);
                self.props.saveZipCode(self.zipCodeInput.value);
				//Clear filter first time once user comes first on self page after searching from login page
				self.props.saveProductLineFilters(null);
				//Reset List first then new values will be added
		        self.props.resetProductNumberKeywordResultList();
                //Parameters were saved on change of text field in store, so just redirect to result page and read from store.
				self.setState({
					errorMessage: '',
					disableGoButtons: true
				});
				self.props.resetProductAvailabilityResultList();
				self.props.checkAndSetSearchResult(
					'product-line',
					self.accountNumberInput.value,
					self.zipCodeInput.value,
					"",
					self.productLineSelect.value,
					() => {
						self.setState({
							errorMessage: 'No results found.',
							disableGoButtons: false
						});
					}
				);
				//Make parallel call for narrow your result filters
				self.props.saveProductLineNarrowYourResultsFilters(null);
				//get categoryId
				const categoryId = self.productLineSelect.value.replace('?N=','');
				self.props.getProductLineNarrorYourResultFilters("requestType=getProductLine&categoryId="+categoryId);
            }
        }
    }

    handleLoginSubmit(event) {
        event.preventDefault();
		const self = this;
		window.location.href = routes.ssoUrl;
    }


	afterLoginProcess(){
		const self = this;
		let userDetails = '';
		self.props.resetUserDetails();
		const queryParams = new URLSearchParams(window.location.search);
    	const jwtToken = (queryParams && queryParams.get('token') ? queryParams.get('token') : null );
		if(jwtToken){
			self.props.getPunchOutData(`token=${jwtToken}`,response => {
				if(response.status){
					console.log(response.responseObject)
					userDetails = response.responseObject.punchOutDetails;
					this.processUserdetails(userDetails);
				}
				else{
					browserHistory.push('/login');
				}
				
			});
		}
		else{
			const cookies = document.cookie.split(';');
			for (let i = 0; i < cookies.length; i++) {
			  const cookie = cookies[i].trim();
			  if (cookie.startsWith(`userDetails=`)) {
				userDetails = cookie.substring(`userDetails=`.length, cookie.length);
				document.cookie = `userDetails=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=geappliancescustomernet.com; path=/;`;
				break;
			  }
			}
			this.processUserdetails(userDetails);
		}
	}

	processUserdetails(userDetails){
		/*Temparory fix for local development
			1. Open QA 
			2. Go to console
			3. Login 
			4. Copy the userdetails value
			5. Assig the value to below userDetails varaible.
			6. Uncomment the code. 
			7. Hit localhsot:3000
		*/
		//userDetails = "lP9NdZz6liC3AXOLSUAbjDcfABmOMozdHzR9pUyXrvdjgtW6s3iCvWPj1E6wFu/QyG3L3frsoBeBt9eS5h42BL8+AUnnoyxXnlnlFbjorneM7QuM3Bgm/74FdR1SI3bAUB0QiVnY99PhAWvF0PCjOZUIFjyznu0qJtaLN2YzeuH6IVhg0dNXSYwuIc8Jp/fntdTXfjrvY/UqGP9Iwpg4LCvpfdPfBNx4G5k2bMyRTv+9ZfZjweB7MBcHwi5wKsW8It7WEkF7fFlNXJVgHVPOAcpq6x/PaQB3yJb9Dcxgxg8byZOVn0DyL/Dh7I0oxGWcmC46Y0J1Ji7Pq/AfXH1d1RK4/k4Fu+W9DoW2BWP4LQVQyFzXw/XbFwg2EbuIVLio35gnyxqar5L8DolUR6fA6aMFWzNAPM9US9oWqVSpQus2Nmjc5TmayOByKBwpSeWXHeeBq9CiyYr2PnYbHRSsV1Bs/I8fMzXmt1V6lc8PqriFf6ToDgOF6P0HdKbfT3IpfeLBT+BWy1C76guopodocW87nCa7a3NCYSmh6o4cuXINfjhja41uCpItz9bsAwulWCDAxGkRNJlVsqJeQ/fuxoJKcKQ4gxpSbwYUW677ImmyzLG8YurICjkxioiw4n6LBCI7Ak52w1Z+0j0m3EuGpluFYhRColj6WYg7Es9p15yqwr7QcRzs7FqcaEcV1jlSfseswYq3dsmwX6l0LVer2iFOTBvFpWmwWVtVKNCDivhShA5+ms9XSQeYITXOQjGtJD/lJOa1wyr9rp7Fgf1kXPTB0qJh8fItMWq3AQMeN9zmiFekli8AdueQMBCZGluCVs18xej73x3GwUxrbms9hI9qTQcz7kW05OWSossPPzP8z9PMSThOwLeGzEs8xtruJvItEjcdraEKZnNjMLMjOhGxsAy+kP2x3RznhEtGeWOreypvA+pl6row9364YsSC9suqHqjvwCLfwtKb5CO3JqG5ULkN3CdKoK2YDOAGA84=";

		
		const self = this;
		if (userDetails && userDetails != "loggedInUser") {
			console.log('User Details:', userDetails.trim());
		  const encryptedBase64Key = routes.userDetailsKey;
		  const parsedBase64Key = enc.Base64.parse(encryptedBase64Key);
		  const decryptedData = AES.decrypt(userDetails, parsedBase64Key, {
			  mode: mode.ECB,
			  padding: pad.Pkcs7
		  });
		  let decryptedText = decryptedData.toString(enc.Utf8);
		  let response = {
			userDetails  : JSON.parse(decryptedText)
		  };
		  if(response.userDetails.isOktaLogin == false && response.userDetails.typeOfUser == 'employee'){
			self.setState({
				genericDialogHeading: "Login information",
				genericDialogText: '<p>Please use the blue GE Appliances Employee Login button. </p>',
				modalButtons: 'ok',
				showOauthMessageForEmployeeUserDialog : true
			}, () => {
				self.handleDialog('GenericOverlayDialog', true);
			});
			return;
		  }
		  else{
			response.userDetails.gessouid ='';
			self.props.saveUserDetails({...response.userDetails, isAdmin: null, isInDL: response.userDetails.adminAccess, isSiteManagementAccess: response.userDetails.manageSiteAccess, isASM: null, otherASM: null, validUser: true});
			// self.props.updateInvalidAttempt({inValidLoginAttempts: 0});
			self.props.saveInvalidAttempt(0);
			//Update localstorage Details
			const typeOfUser = self.setLocalStorageDetailsUpdate(response);
			//Reset any suggestion of prelogin search in product numbers
			self.props.resetSearchKeywordSuggestionList();
			// This case covers issue which occurs when user enters keyword in prelogin and then try to login with correct credentials
			
			if (response.userDetails.isNonGEASsoUser) {
				self.fetchNonGEASSOUserDetails(response.userDetails.sso);
			} else if(typeOfUser === 'customer' && response && response.userDetails && !(response.userDetails.punchOutAccess)) {
				self.fetchUserDetails(response.userDetails.sso, typeOfUser);
			} else {
				self.fetchHomePageAssets();
			}
		}
	  }
	  else if(userDetails && userDetails == "loggedInUser"){
		window.location.href = routes.logoutSSOUrl;
	  }
	  else{
		  browserHistory.push('/login');
	  }
	}

	fetchHomePageAssets(callback) {
		const self = this,
			{ assets } = self.props.state.homepage;
		if(!assets || !assets.responseObject) {
			self.props.getAssets(true, response => {
				self.props.populateLatestHomePageAssets();
				setTimeout(() => {
					// redirect to home page
					browserHistory.push('/home');
				}, 100);
				callback && callback();
			});
		} else {
			callback && callback();
		}
	}

	setLocalStorageDetailsUpdate(response) {
		let expiryTime = new Date();

		let gessouid = "", typeOfUser = response.userDetails.typeOfUser;

		localStorage.setItem(localStorageVar, JSON.stringify({
			...response.userDetails,
			isSiteManagementAccess: response.userDetails.manageSiteAccess,
			punchOutAccess : response.userDetails.punchOutAccess,
			punchOutAccNumber : response.userDetails.punchOutAccNumber,
			punchOutSalesNumber : response.userDetails.punchOutSalesNumber,
			punchoutRedirectUrl: response.userDetails.punchoutRedirectUrl,
			punchoutPostUrl: response.userDetails.punchoutPostUrl,
			punchoutBuyerCookie: response.userDetails.punchoutBuyerCookie,
			punchoutFromIdentity: response.userDetails.punchoutFromIdentity,
			punchoutToIdentity: response.userDetails.punchoutToIdentity,
			punchoutSenderIdentity: response.userDetails.punchoutSenderIdentity,
			punchoutSenderPassword: response.userDetails.punchoutSenderPassword,
			punchoutUserAgent: response.userDetails.punchoutUserAgent,
			payloadID: response.userDetails.payloadID,
			isInDL: response.userDetails.adminAccess,
			omAccess : response.userDetails.omAccess,
			gessouid: gessouid,
			typeOfUser: typeOfUser,
			expiryTime: expiryTime.setHours(expiryTime.getHours() + 2),
			isOktaLogin : response.userDetails.isOktaLogin,
		}));
		localStorage.setItem("punchOutAccess", response.userDetails.punchOutAccess ? response.userDetails.punchOutAccess : false)
		localStorage.setItem("punchOutPostUrl", response.userDetails.punchoutPostUrl);
		return typeOfUser;
	}

    getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	//
    // setLoginParameters(sso){
    //     //If there at least one approved account
    //     var redirectUrl = this.getParameterByName('redirectUrl',window.location.href);
    //     if(redirectUrl === null || redirectUrl === '') {
    //         browserHistory.push('/home');
    //     } else {
    //         var localStrogeObj = localStorage.getItem(redirectURLCNetVar);
    // 		localStrogeObj = localStrogeObj ? JSON.parse(localStrogeObj) : null;
	//
    //         let ssoId = localStrogeObj.sso;
    //         let typeOfUser = localStrogeObj.typeOfUser;
	//
    //         if(typeOfUser !== 'employee' && ssoId === sso){
    //             browserHistory.push(redirectUrl);
    //         } else {
    //             browserHistory.push('/home');
    //         }
    //     }
    // }

	getLocalStorageVar(variableName) {
		var localStrogeObj = localStorage.getItem(variableName);
		localStrogeObj = localStrogeObj?JSON.parse(localStrogeObj):null;
		return localStrogeObj;
	}

	updateAccountListToLocalStorage(accountList) {
		let localStrogeObj = this.getLocalStorageVar(localStorageVar);
		localStrogeObj = {
			...localStrogeObj,
			accountList
		};
		localStorage.setItem(localStorageVar, JSON.stringify(localStrogeObj));
	}

	saveUserOtherDetailsToLocalStorage(userOtherDetails) {
		let localStrogeObj = this.getLocalStorageVar(localStorageVar);
		localStrogeObj = {
			...localStrogeObj,
			userOtherDetails
		};
		localStorage.setItem(localStorageVar, JSON.stringify(localStrogeObj));
	}

	callBackToCheckAccountSetProperlyOrNot() {
		const self = this;
		const {
			getUserAccountsData: response,
			getUserAccountsCallCompleted,
			getLocalUserData,
			getLocalUserCallCompleted,
		} = self.state;
		if(getUserAccountsCallCompleted && getLocalUserCallCompleted) {
			// Check if all accounts approvalStatus is "Deleted" or note
			if(getLocalUserData.responseObject.accounts.find(account => account.approvalStatus === 'Approved')) {
				//save to store
				self.props.saveApprovedAccountDetails(response);
				//save to localstorage
				self.updateAccountListToLocalStorage(response);

				self.fetchHomePageAssets();
			} else {
				self.setState({
					genericDialogHeading: 'User Setup',
					genericDialogText: 'Your user ID may be set up improperly. Please contact the CustomerNet Help Desk at 1-800-242-1333.',
					modalButtons: 'ok',
				}, () => {
					self.handleDialog('AccountNotSetupProperlyOverlayDialog', true, null);
				});
			}
		}
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	fetchUserDetails(useId, typeOfUser) {
		const self = this;
		//Make service call to check whether user has approved account or pending
		self.props.getUserDetails(`userId=${useId}&requestType=getUserDetails`, (resp) => {
			const { userDetails } = self.props.state.user;
			self.props.saveUserOtherDetails(resp);
			self.saveUserOtherDetailsToLocalStorage(resp);
			if(resp.status && resp.responseObject && resp.responseObject.length > 0) {
				// Make second service call with PERSON_PARTY_ID
				self.props.getApprovedAccounts(`personPartyId=${resp.responseObject[0].PERSON_PARTY_ID}&requestType=getUserAccounts`, response => {
					response.responseObject = response.responseObject ? response.responseObject.filter(item => item.RELATIONSHIP_STATUS === 'A' && item.ACCT_ROLE_STATUS === 'A') : [];
					// service will return approved account
					if(response.status && response.responseObject && response.responseObject.length > 0) {
						self.setState({
							getUserAccountsData: response,
							getUserAccountsCallCompleted: true,
						}, () => {
							self.callBackToCheckAccountSetProperlyOrNot();
						});
					} else {
						// if there is no approved account redirect to request-access page
						browserHistory.push('/prelogin/request-access');
					}
				});
				self.props.getLocalUserDetails(`userId=${useId}&requestType=getLocalUser&personPartyId=${resp.responseObject[0].PERSON_PARTY_ID}`, true, response => {
					if(response.status) {
						if(response.responseObject) {
							if(response.responseObject.accounts && response.responseObject.accounts.length > 0) {
								self.setState({
									getLocalUserData: response,
									getLocalUserCallCompleted: true,
								}, () => {
									self.callBackToCheckAccountSetProperlyOrNot();
								});
							}
						}
					} else {
						browserHistory.push('/prelogin/error');
					}
				});
			} else {
				typeOfUser === 'customer' && self.props.getLocalUserDetails(`userId=${useId}&requestType=getLocalUser`, true, response => {
					if(response.status) {
						if(response.responseObject) {
							if(response.responseObject.accounts && response.responseObject.accounts.length > 0) {
								if(_.filter(response.responseObject.accounts, ['approvalStatus', 'Pending']).length > 0) {
									// if there is no approved account redirect to no-account page
									browserHistory.push('/prelogin/no-account');
								}
							} else if(response.responseObject.accounts && response.responseObject.accounts.length === 0) {
								// if there is no approved account redirect to request-access page
								browserHistory.push('/prelogin/request-access');
							}
						} else {
							self.saveRegistraionDetailsAndRedirect(userDetails);
						}
					} else {
						browserHistory.push('/prelogin/error');
					}
				});
			}
		});
	}

	getAccountDetails = (accountNumbers, sso, callback) => {
		const requests = [];
		accountNumbers.forEach(accountNumber => {
			requests.push(
				sendRequest(
					bootAPIUrl,
					users.account.path,
					'',
					users.account.method,
					`accountNumber=${accountNumber}&requestType=getAccountDetails&ssoId=${sso}`
				)
			);
		});

		if (requests.length) {
			Promise.all(requests)
				.then(accountDetailsResponses => {
					this.approvedAccountDetails = this.approvedAccountDetails || { responseObject: [] };

					accountDetailsResponses.forEach(accountDetailsResponse => {
						if (accountDetailsResponse.responseObject && accountDetailsResponse.responseObject.length) {
							this.approvedAccountDetails.responseObject.push(accountDetailsResponse.responseObject[0]);
						}
					});

					callback && callback();
				})
		}
	}

	updateAccountDetailsInBatches = (batches, sso) => {
		if (batches.length) {
			const accountNumbers = batches.shift();
			this.getAccountDetails(accountNumbers, sso, () => {
				this.updateAccountDetailsInBatches(batches, sso);
			});
		} else {
			this.props.ajaxRequestCompleted()
			this.props.saveApprovedAccountDetails(this.approvedAccountDetails);
			this.updateAccountListToLocalStorage(this.approvedAccountDetails);
			this.fetchHomePageAssets();
			this.approvedAccountDetails = null;
		}
	}

	fetchNonGEASSOUserDetails = sso => {
		this.props.getNonGEASSOUserAccounts(`requestType=nonGeaSsoAccount&sso=${sso}`, nonGEASSOUserAccountsResponse => {
			const nonGEASSOUserDetails = nonGEASSOUserAccountsResponse.responseObject;
			if (nonGEASSOUserDetails && nonGEASSOUserDetails.accountNumbers && nonGEASSOUserDetails.accountNumbers.length) {
				this.props.ajaxRequestInitiated();
				this.updateAccountDetailsInBatches(_.chunk(nonGEASSOUserDetails.accountNumbers, 10), sso);
			} else {
				browserHistory.push('/prelogin/no-account');
			}
		})
	}

	saveRegistraionDetailsAndRedirect(userDetails) {
		const self = this;
		//If users credentials are valid but profile is not available, then redirect to registration page
		self.props.saveSSORegistrationDetails({
			firstName: userDetails.firstName,
			lastName: userDetails.lastName,
			emailAddress: userDetails.email,
			sso: userDetails.sso,
			gessouid: userDetails.gessouid
		});
		if(userDetails && !(userDetails.punchOutAccess)){
			browserHistory.push('/prelogin/ge-custnet-registration');
		}
			
	}

    handleCheckBox(event){
        if(event.target.checked) {
			this.setCookie('ssoId', this.state.ssoId);
		} else {
            this.delCookie('ssoId');
        }
    }

    validateFields(fields) {
        var errorOccured = false;
        for(var i=0;i<fields.length;i++) {
            //required field validation
            var origClassName = fields[i].field.className;
            fields[i].field.className = (fields[i].field.value === "")?"error":"";
            //minimum size validation
            if(fields[i].minLength && fields[i].field.value !== "") {
                fields[i].field.className = (fields[i].field.value.length !== fields[i].minLength)?"error":"";
            }
            if(origClassName.indexOf("invalid") !== -1) {
                fields[i].field.className = "invalid error";
                errorOccured = true;
            }
            if(errorOccured===false && fields[i].field.value === "" ) {
                errorOccured = true;
                fields[i].field.focus();
            }
        }
        return errorOccured;
    }

    handleClickOfSuggest(event) {
        event.preventDefault();
		var self = this;
        const value = this.productNumberInput.value;

        if(value.indexOf(" ") === -1) {
            this.productNumberInput.value = event.target.text;
        } else {
            var temp = this.productNumberInput.value.split(" ");
            if(temp[temp.length-1] === "") temp.pop();
            temp[temp.length-1] = event.target.text;
            this.productNumberInput.value = temp.join(" ");
        }

		//save all search string in store for showing next result page
        self.props.savePostLoginSearchKeyword(this.productNumberInput.value);
        self.props.showHideAutoSelect(false);
    }

    validateSearchKeyword(event) {
		var value = event.target.value,
            lastCharacter = value.substring(value.length-1),
            lastKeyword = value.split(" "),
            noOfSpace = value.split(" ").length;
        this.setState({
            productNumberError: ""
        });
        //(lastCharacter === " ")?lastKeyword.pop():'';
        lastKeyword = lastKeyword[lastKeyword.length-1];
        if((value === "" && event.charCode === 32 )||
            (lastCharacter === " " && lastKeyword !== "")||
            (lastKeyword.length < 3 && event.charCode === 32)||
            (noOfSpace === 5 && event.charCode === 32 )||
            noOfSpace===6) {
            event.preventDefault();
        }
        var errorMsg = "";
        if((noOfSpace === 5 && event.charCode === 32 )||noOfSpace===6) {
            errorMsg = "You can only enter 5 keywords separated by space."
        }
        if(lastCharacter === " " && lastKeyword !== "") {
            errorMsg = "There should be only one space between each keyword."
        }
        if(value === "" && event.charCode === 32) {
            errorMsg = "Keyword can not be start with space character."
        }
        if(lastKeyword.length < 3 && event.charCode === 32) {
            errorMsg = "Please enter valid minimum 3 characters in each keyword."
        }
        this.setState({
            productNumberError: errorMsg
        });
    }

	handleAutoSuggests(flag) {
		var self = this;
		setTimeout(function() {
			self.setState({
				showSuggestion: flag
			});
		}, 200);
	}

	handleAccountNotSetupProperlyOverlayDialog(dialog, flag, event) {
		event && event.preventDefault();
		const self = this;
		self.removeLocalStorageVar(localStorageVar);
		self.removeLocalStorageVar(redirectURLCNetVar);
		this.handleDialog(dialog, flag, event);
	}

	removeLocalStorageVar(variableName) {
		localStorage.removeItem(variableName);
	}

	logout(){
		const self =  this;
		self.setState({
			showOauthMessageForEmployeeUserDialog:false
		}, () => {
			self.props.logout();
		});
		
	}

    render() {
        const self = this;
		const isdisabledTextBox = !(this.props.state.product.accountDetail && this.props.state.product.accountDetail.status && this.props.state.product.zipCodeDetail && this.props.state.product.zipCodeDetail.status);
        const applicationUrl = window.location.origin;
		return (
            <div className="geStoreHomePageLayout">
	            <div className="geStoreHomePageLayoutLeftSide">
	              	<h1 className="loginTitle">Login</h1>
					{(this.props.state && this.props.state.user && this.props.state.user.userDetails && !this.props.state.user.userDetails.validUser) && this.props.state.user.inValidLoginAttempts > 0 &&
						<p className="red bold">Attempt {this.props.state.user.inValidLoginAttempts} of 5 failed.</p>
					}
	              	<p className="red bold">{this.state.customLoginErrorMessage}</p>
	              	<form onSubmit={this.handleLoginSubmit.bind(this)}>
		               {/* {(this.props.state && this.props.state.user && this.props.state.user.userDetails && !this.props.state.user.userDetails.validUser)
		                    ?<p className="red"><strong>You have entered an invalid User Id or password. Try re-entering the information below.</strong></p>
		                    :null
		                }
						<p>
		                  	<label className="labelA" htmlFor="ssoId">Single Sign On User ID:</label><br />
		                  	<input type="text" defaultValue={this.state.ssoId} name="ssoId" size={9} id="ssoId" onChange={(event) => this.handleLoginFormChange("ssoId", event)} ref={(input) => this.ssoIdInput = input} />
		                </p>
		                <p>
		                  	<label className="labelA" htmlFor="password">Password:</label><br />
		                  	<input type="password" name="password" id="password" onChange={(event) => this.handleLoginFormChange("password", event)} ref={(input) => this.passwordInput = input}/>
		                </p>
		                <p>
		                  	<input type="checkbox" name="rememberCheckbox" id="rememberCheckbox" onClick={this.handleCheckBox.bind(this)} defaultChecked={this.state.ssoId?true:false} />
		                  	<label htmlFor="rememberCheckbox">Remember my User ID</label>
					</p>
					<p>
							<b>The login process for GE Appliances CustomerNet has changed, but your existing SSO userid and password are still valid.  Please click LOGIN to proceed to a new page to enter your credentials.</b>
						</p>
					*/}

					
						

		                <p style={{textAlign: "center"}}>
							{/*start okta login single*/}
							<input className="submitButton orangeButton" type="submit" value="CUSTOMER LOGIN" />
		                </p>
						{/*<p>
							<div>
			<label>
			<input
				type="checkbox"
				checked={this.state.isChecked}
				onChange={this.handleCheckboxChange}
			/>
			<b>Show punchout functionality</b>
			</label>
			{this.state.isChecked && (
			<div>
				<textarea
				rows="4"
				cols="50"
				value={this.state.textAreaValue} // Value mapped to state
				onChange={this.handleTextAreaChange} // Update state on change
				/>

				<button style={{marginTop: "10px"}} onClick={this.handlePunchLoginSubmit.bind(this)}><span>Punchout Login</span></button>
			</div>
			
			)}
							</div>
						</p>*/}
	              	</form>
					<p className="forgotUserId">
						<a className="forgotUserIdLink" href={"https://b2b.geappliances.com/pwm/public/forgottenusername?forwardURL="+applicationUrl}>Forgot User ID</a>
					</p>
					<p className="forgotPassword">
						<a className="forgotPasswordLink" href={"https://b2b.geappliances.com/pwm/public/forgottenpassword?forwardURL="+applicationUrl}>Forgot Password</a>
					</p>
					<hr className="clear" />
					<h2 className="noMarginBottom">Need to make some changes?</h2>
					<p className="noMarginTop">
						<a href={"https://b2b.geappliances.com/pwm/private/login?forwardURL="+applicationUrl}>Modify Account</a>
					</p>
					<h2 className="noMarginBottom">First time user?</h2>
					<p className="noMarginTop">
						<a href={"https://b2b.geappliances.com/pwm/public/newuser?forwardURL="+applicationUrl}>Request Access</a>
					</p>
					<h2 className="noMarginBottom">
						Need Registration<br />Assistance? Click<br /><a href="" className="registrationLink" onClick={this.handleNewUserRegistrationDocuments.bind(this)}>How to Register?</a><br />or Call 1-800-242-1333
					</h2>	
					{/*start okta login*/}
					<div>
						<form onSubmit={this.handleSSOLoginSubmit.bind(this)}>
							<p style={{textAlign: "center"}}>
								<input 
									className="submitSSOButton blueButton" 
									type="submit" 
									value="GE APPLIANCES EMPLOYEE LOGIN" 
									style={{ 
										width: "180px", 
										whiteSpace: "pre-wrap", 
										textAlign: "center", 
										padding: "10px" ,
										position: "relative",
										right: "5px"
									}} 
								/>
							</p>
						</form>	
					</div>		
					{/*end okta login*/}
	            </div>


	            <div className="geStoreHomePageLayoutRightSideResponsive">
	              <img className="rightSideImage" src="../images/ge-store-login-page.jpg" alt="" />
	              <div className="prelaunchSearch">
	                <h3 className="mt-0" style={{lineHeight: 1.5}}>
						For Parts Availability, please login above
						<br />
						For all other Product Availability:
					</h3>
	                <p className="red"><strong>{this.state.errorMessage}</strong></p>
	                {this.props.state.product.accountDetail && this.props.state.product.accountDetail.responseObject && (!this.props.state.product.accountDetail.status || this.props.state.product.accountDetail.responseObject.length === 0 || this.props.state.product.accountDetail.responseObject[0].STATUS !== "A")
	                    ?<p className="red"><strong>You have entered an invalid Account Number. Try re-entering the information below.</strong></p>
	                    :null
	                }
	                {this.props.state.product.zipCodeDetail && !this.props.state.product.zipCodeDetail.status
	                    ?<p className="red"><strong>You have entered an invalid Zip Code. Try re-entering the information below.</strong></p>
	                    :null
	                }
					<div className="row">
						<div className="columns large-6 medium-6 small-6">
							<div className="row">
								<div className="columns large-8 medium-7 small-12">
									<label htmlFor="loginAccountNumber"><b><span className="hide-for-small inline">Enter</span> Account #</b></label>
								</div>
								<div className="columns large-4 medium-5 small-12">
									<input
										type="text"
										defaultValue={this.props.state.product.accountNumber}
										className={(this.props.state.product.accountDetail && (!this.props.state.product.accountDetail.status || this.props.state.product.accountDetail.responseObject.length === 0))?"invalid error":""}
										name="accountNumber"
										onKeyPress={this.props.acceptNumbersOnly}
										ref={(input) => { this.accountNumberInput = input; }}
										onBlur={this.handleBlurEvent.bind(this)}
										onChange={this.handleChange}
										onPaste={(e) => manipulateClipBoardToKeepNumericsOnly(this.handleChange, e)}
										id="loginAccountNumber"
										style={{width: 100}}
									/>
								</div>
							</div>
							<div className={"loader account-number-loader " + (this.props.state.product.accountDetailProgress?"":"hide")}>&#160;</div>
						</div>
						<div className="columns large-6 medium-6 small-6">
							<div className="row">
								<div className="columns large-8 medium-7 small-12">
									<label htmlFor="loginZipCode"><b>Zip Code</b></label>
								</div>
								<div className="columns large-4 medium-5 small-12">
									<input type="text" defaultValue={this.props.state.product.zipCode} className={(this.props.state.product.zipCodeDetail && !this.props.state.product.zipCodeDetail.status)?"invalid error":""} name="zipCode" onKeyPress={this.acceptsOnlyNumbers} ref={(input) => { this.zipCodeInput = input; }} onBlur={this.handleBlurEvent.bind(this)} onChange={this.handleChange.bind(this)} maxLength={5} id="loginZipCode" style={{width: 100}} />
								</div>
							</div>
							<div className={"loader zip-code-loader " + (this.props.state.product.zipCodeProgress?"":"hide")}>&#160;</div>
						</div>
					</div>
					<h4 className="thEmulator">By Product Number</h4>
					<p>For multiple products, enter a space between product numbers.</p>
					<div className="product-number-error-msg"><p className="red"><strong>{this.state.productNumberError}</strong></p></div>
					<div className="product-number-container">
						<form onSubmit={this.handleProductNumberSubmit.bind(this)}>
							<input type="text" id="outsideProdSearchName" name="outsideProdSearchName"
								ref={(input) => { this.productNumberInput = input; }}
								onChange={this.handleChangeProductNumber.bind(this)}
								onKeyPress={this.validateSearchKeyword.bind(this)}
								onBlur={this.handleAutoSuggests.bind(this, false)}
								onFocus={this.handleAutoSuggests.bind(this, true)}
								className="outsideProdSearchName"
								disabled={isdisabledTextBox}
								autoComplete="off" />&#160;
							<input type="submit" disabled={this.state.disableGoButtons} className="blueButton" value="GO" />
							<div id="product-number-autocomplete" className={(this.state.showSuggestion && this.props.state.searchKeyword.postLoginSearchKeyword.trim() !== ""?"show":"hide")}>
								{this.state.showSearchLoading
									?<div><br/><div className="loader">&#160;</div><br/></div>
									:null
								}
								{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length === 0
									?<div><br/><strong>No Results found.</strong><br/><br/></div>
									:null
								}
								{!this.state.showSearchLoading && this.props.state.searchKeyword.productNumberList && this.props.state.searchKeyword.productNumberList.length > 0 && this.props.state.searchKeyword.productNumberList.map((item, index) => {
									return <a key={index} onClick={self.handleClickOfSuggest.bind(this)} href="">{item.sku}</a>
								})}
							</div>
						</form>
					</div>
					<p />
					<form onSubmit={this.handleProductLineSubmit.bind(this)}>
						<select id="outsideProdSearchLine" name="outsideProdSearchLine" ref={(select) => { this.productLineSelect = select; }} onChange={this.handleChangeProductLine.bind(this)} className="outsideProdSearchLine">
						  <option value="">Select Product Line</option>
							{this.props.state.product.productLineList.map((item, index) => {
								if(item.hideInPrelogin || item.type === 'filter') return null
								return <option key={index} value={"?N="+item.categoryId}>{item.name}</option>
						  })}
						</select> <input type="submit" disabled={this.state.disableGoButtons} className="blueButton" value="GO" />
					</form>
	              </div>
	            </div>
	            {!this.props.state.product.isValidProductNumber?<NoProductResultsFoundOverlayDialog showDialog={true}/>:null}
				{this.state.showAccountNotSetupProperlyOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="AccountNotSetupProperlyOverlayDialog" handleDialog={this.handleAccountNotSetupProperlyOverlayDialog.bind(this)} showDialog={true} />:null}
				{this.state.showOauthMessageForEmployeeUserDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="OauthMessageForEmployeeUserDialog" handleDialog={this.logout.bind(this)} showDialog={true} />:null}
	        </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	saveZipCodeDetail: (data) => dispatch(saveZipCodeDetail(data)),
	saveZipCode: (data) => dispatch(saveZipCode(data)),
	saveAccountNumber: (data) => dispatch(saveAccountNumber(data)),
	saveAccountNumberDetails: (data) => dispatch(saveAccountNumberDetails(data)),
	getAddressList: (queryStringParams, showLoader, callback) => dispatch(getAddressList(queryStringParams, showLoader, callback)),
	getShippingAddresses: (queryStringParams, showLoader, callback, saveToStore) => dispatch(getShippingAddresses(queryStringParams, showLoader, callback, saveToStore)),
	saveProductLine: (data) => dispatch(saveProductLine(data)),
	savePostLoginSearchKeyword: (data) => dispatch(savePostLoginSearchKeyword(data)),
	resetSearchKeywordSuggestionList: () => dispatch(resetSearchKeywordSuggestionList()),
	resetHomePageObjectInStore: () => dispatch(resetHomePageObjectInStore()),
	resetProductNumberKeywordResultList: () => dispatch(resetProductNumberKeywordResultList()),
	saveSelectedAccountAndPriceSource: (data) => dispatch(saveSelectedAccountAndPriceSource(data)),
	saveAccountNumberPostLogin: (data) => dispatch(saveAccountNumberPostLogin(data)),
	showHideAutoSelect: (data) => dispatch(showHideAutoSelect(data)),
	saveSearchKeywordSuggestionList: (data) => dispatch(saveSearchKeywordSuggestionList(data)),
	saveProductLineFilters: (data) => dispatch(saveProductLineFilters(data)),
	getSearchKeywordSuggestionList: (payload, callback) => dispatch(getSearchKeywordSuggestionList(payload, callback)),
	getAccountDetails: (queryStringParams, showLoader, callback) => dispatch(getAccountDetails(queryStringParams, showLoader, callback)),
	saveAccountDetail: (accountDetail) => dispatch(saveAccountDetail(accountDetail)),
	checkCredentials: (payload, callback) => dispatch(checkCredentials(payload, callback)),
	saveUserDetails: (data) => dispatch(saveUserDetails(data)),
	logout: () => dispatch(logout()),
	resetUserDetails: () => dispatch(resetUserDetails()),
	getPunchOutData: (queryStringParams,callback) => dispatch(getPunchOutData(queryStringParams,callback)),
	postPunchOutData: (data,postUrl,callback) => dispatch(postPunchOutData(data,postUrl,callback)),
	getUserDetails: (queryStringParams, callback) => dispatch(getUserDetails(queryStringParams, callback)),
	getLocalUserDetails: (queryStringParams, showLoader, callback) => dispatch(getLocalUserDetails(queryStringParams, showLoader, callback)),
	getApprovedAccounts: (queryStringParams, callback) => dispatch(getApprovedAccounts(queryStringParams, callback)),
	saveApprovedAccountDetails: (data) => dispatch(saveApprovedAccountDetails(data)),
	saveSSORegistrationDetails: (data) => dispatch(saveSSORegistrationDetails(data)),
	saveUserOtherDetails: (data) => dispatch(saveUserOtherDetails(data)),
	getAssets: (showLoader, callback) => dispatch(getAssets(showLoader, callback)),
	populateLatestHomePageAssets: () => dispatch(populateLatestHomePageAssets()),
	saveProductLineNarrowYourResultsFilters: (data) => dispatch(saveProductLineNarrowYourResultsFilters(data)),
	showAccountDetailProgress: (data) => dispatch(showAccountDetailProgress(data)),
	showZipCodeLoading: (data) => dispatch(showZipCodeLoading(data)),
	getProductLineNarrorYourResultFilters: (payload) => dispatch(getProductLineNarrorYourResultFilters(payload)),
	updateHomePageAssetsFromBackup: (data) => dispatch(updateHomePageAssetsFromBackup(data)),
	saveInvalidAttempt: (data) => dispatch(saveInvalidAttempt(data)),
	saveShippingAddresses: (data) => dispatch(saveShippingAddresses(data)),
	resetProductAvailabilityResultList: () => dispatch(resetProductAvailabilityResultList()),
	updateInvalidAttempt: (payload, callback) => dispatch(updateInvalidAttempt(payload, callback)),
	getRegistrationHelpDoc: (queryStringParams, callback) => dispatch(getRegistrationHelpDoc(queryStringParams, callback)),
	getNonGEASSOUserAccounts: (queryString, callback) => dispatch(getNonGEASSOUserAccounts(queryString, callback)),
	ajaxRequestInitiated: data => dispatch(ajaxRequestInitiated(data)),
	ajaxRequestCompleted: data => dispatch(ajaxRequestCompleted(data))
});

Home = connect(mapStateToProps, mapDispatchToProps)(Home);
export default Home;


// WEBPACK FOOTER //
// ./src/App/components/PreLogin/Login/index.js